module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6587/img/business-types/event-management.png"